import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Menu from './Menu';
import Header from './Header';
import ThemeSetting from './ThemeSetting';
import Searchbar from './Searchbar';
import Rightbar from './Rightbar';
import Megamenu from './Megamenu';
import Routes from '../Route';
import Clients from '../Projects/Vendors';
import NotFound from '../Authentication/404';
import { useSelector } from 'react-redux';
import VendorQuestionnaireDashboard from '../RiskManagement/vendorquestionnairesdashboard ';

const Layout = (props) => {
  const auth = useSelector(state => state.auth.user?.organisationId?.services);
  const redirectPath = localStorage.getItem('redirectPath');
  const accessLevel = useSelector(state => state.auth.user?.accessLevel);
  const shouldRenderVendor = auth?.length === 1 && auth[0] === "TPSA";

  useEffect(() => {
    if (redirectPath) {
      localStorage.removeItem('redirectPath');
    }
  }, []);

  return (
    <>
      {/* <ThemeSetting /> */}
      <div className="overlay" />
      <div id="wrapper">
        <Header />
        <Searchbar />
        <Megamenu />
        <Rightbar />
        <Menu {...props} />
        <div id="main-content">
          <Switch>
            {redirectPath && <Redirect to={redirectPath} />}
            {shouldRenderVendor && <Route exact path="/" component={Clients} />}
            {accessLevel == "tprm-question-responder" && <Route exact path="/" component={VendorQuestionnaireDashboard} />}
            {Routes.map((layout, i) => (
              <Route
                key={`r${i}`}
                exact={layout.exact}
                path={layout.path}
                component={layout.component}
              />
            ))}
            {/* Catch-all route for 404 pages */}
            <Route component={NotFound} />
          </Switch>
          <div style={{ textAlign: 'center', padding: '10px', fontSize: '14px', color: '#666' }}>
            Powered by brandsek
          </div>
        </div>

      </div>
    </>
  );
};

export default Layout;
